import PeopleIcon from "@mui/icons-material/People";
import ViewKanbanOutlinedIcon from "@mui/icons-material/ViewKanbanOutlined";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import EuroIcon from "@mui/icons-material/Euro";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import AutoGraphOutlinedIcon from "@mui/icons-material/AutoGraphOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import WaterfallChartOutlinedIcon from "@mui/icons-material/WaterfallChartOutlined";
import AutoModeOutlinedIcon from "@mui/icons-material/AutoModeOutlined";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import RoundaboutRightOutlinedIcon from "@mui/icons-material/RoundaboutRightOutlined";
import AlignHorizontalLeftOutlinedIcon from "@mui/icons-material/AlignHorizontalLeftOutlined";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import DvrOutlinedIcon from "@mui/icons-material/DvrOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import VideoCameraFrontOutlinedIcon from "@mui/icons-material/VideoCameraFrontOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import AssuredWorkloadOutlinedIcon from "@mui/icons-material/AssuredWorkloadOutlined";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import DryCleaningOutlinedIcon from "@mui/icons-material/DryCleaningOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import SportsCricketOutlinedIcon from "@mui/icons-material/SportsCricketOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ImportExportOutlinedIcon from "@mui/icons-material/ImportExportOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import ChecklistRtlOutlinedIcon from "@mui/icons-material/ChecklistRtlOutlined";
import BubbleChartOutlinedIcon from "@mui/icons-material/BubbleChartOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import MicNoneOutlinedIcon from "@mui/icons-material/MicNoneOutlined";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";

const ICON_MAP = {
  People: PeopleIcon,
  ViewKanbanOutlined: ViewKanbanOutlinedIcon,
  PriceCheck: PriceCheckIcon,
  ContactMailOutlined: ContactMailOutlinedIcon,
  Euro: EuroIcon,
  DashboardCustomizeOutlined: DashboardCustomizeOutlinedIcon,
  AutoGraphOutlined: AutoGraphOutlinedIcon,
  AccountBalanceWalletOutlined: AccountBalanceWalletOutlinedIcon,
  PointOfSaleOutlined: PointOfSaleOutlinedIcon,
  StorefrontOutlined: StorefrontOutlinedIcon,
  WaterfallChartOutlined: WaterfallChartOutlinedIcon,
  AutoModeOutlined: AutoModeOutlinedIcon,
  CalendarToday: CalendarTodayIcon,
  RoundaboutRightOutlined: RoundaboutRightOutlinedIcon,
  AlignHorizontalLeftOutlined: AlignHorizontalLeftOutlinedIcon,
  PrecisionManufacturing: PrecisionManufacturingIcon,
  DrawOutlined: DrawOutlinedIcon,
  DesignServicesOutlined: DesignServicesOutlinedIcon,
  ColorLensOutlined: ColorLensOutlinedIcon,
  LocationOnOutlined: LocationOnOutlinedIcon,
  AssessmentOutlined: AssessmentOutlinedIcon,
  AccountTreeOutlined: AccountTreeOutlinedIcon,
  DvrOutlined: DvrOutlinedIcon,
  RequestQuoteOutlined: RequestQuoteOutlinedIcon,
  VideoCameraFrontOutlined: VideoCameraFrontOutlinedIcon,
  InboxOutlined: InboxOutlinedIcon,
  BarChartOutlined: BarChartOutlinedIcon,
  FactoryOutlined: FactoryOutlinedIcon,
  LocalShippingOutlined: LocalShippingOutlinedIcon,
  AssuredWorkloadOutlined: AssuredWorkloadOutlinedIcon,
  MiscellaneousServices: MiscellaneousServicesIcon,
  DryCleaningOutlined: DryCleaningOutlinedIcon,
  SpaceDashboardOutlined: SpaceDashboardOutlinedIcon,
  SportsCricketOutlined: SportsCricketOutlinedIcon,
  DescriptionOutlined: DescriptionOutlinedIcon,
  SchoolOutlined: SchoolOutlinedIcon,
  CampaignOutlined: CampaignOutlinedIcon,
  LibraryBooksOutlined: LibraryBooksOutlinedIcon,
  EventOutlined: EventOutlinedIcon,
  Inventory2Outlined: Inventory2OutlinedIcon,
  BadgeOutlined: BadgeOutlinedIcon,
  AccessTimeOutlined: AccessTimeOutlinedIcon,
  ImportExportOutlined: ImportExportOutlinedIcon,
  AutoAwesomeOutlined: AutoAwesomeOutlinedIcon,
  PaymentOutlined: PaymentOutlinedIcon,
  ChecklistRtlOutlined: ChecklistRtlOutlinedIcon,
  BubbleChartOutlined: BubbleChartOutlinedIcon,
  AccountBalanceOutlined: AccountBalanceOutlinedIcon,
  InsightsOutlined: InsightsOutlinedIcon,
  LeaderboardOutlined: LeaderboardOutlinedIcon,
  MicNoneOutlined: MicNoneOutlinedIcon,
};

export function getNavIcon(iconKey) {
  return ICON_MAP[iconKey] || WidgetsOutlinedIcon;
}
